import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/08bd8494f3fc186aa6bc9b8fa3eef0ef.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-900/80 via-stone-800/70 to-stone-900/60" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 flex flex-col lg:flex-row items-center gap-12">
        {/* Left */}
        <div className="flex-1 text-center lg:text-left">
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Begin Your
            <br />
            <span className="text-amber-400">Healing Journey</span>
          </h2>
          <p className="text-white/75 text-base max-w-md mx-auto lg:mx-0 leading-relaxed">
            Whether you need expert endocrinology care or spiritual guidance,
            Dr. Sheldon Mckenzie is here to walk with you every step of the way.
          </p>
        </div>

        {/* Right Card */}
        <div className="w-full lg:w-96 bg-white rounded-2xl p-8">
          <h3
            className="text-xl font-bold text-stone-800 mb-1"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Schedule a Consultation
          </h3>
          <p className="text-stone-400 text-sm mb-6">
            In-person or telehealth available
          </p>
          <div className="flex flex-col gap-3">
            <Link
              to="/consultation"
              className="w-full py-3 rounded-full bg-amber-700 text-white text-sm font-semibold text-center hover:bg-amber-800 transition-all whitespace-nowrap cursor-pointer"
            >
              Book Medical Consultation
            </Link>
            <Link
              to="/ministry"
              className="w-full py-3 rounded-full border border-stone-200 text-stone-700 text-sm font-semibold text-center hover:bg-stone-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Request Pastoral Counseling
            </Link>
            <Link
              to="/contact"
              className="w-full py-3 rounded-full border border-stone-200 text-stone-700 text-sm font-semibold text-center hover:bg-stone-50 transition-all whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </Link>
          </div>
          <p className="text-center text-xs text-stone-400 mt-4">
            Telehealth &bull; In-Person &bull; Same-Week Appointments
          </p>
        </div>
      </div>
    </section>
  );
}
